<div class="help-sub-menu-flyout-card">
  @for (item of items; track item) {
    <ftr-help-sub-menu-flyout-item [item]="item"></ftr-help-sub-menu-flyout-item>
  }
</div>
